import {type Action, createReducer, on} from '@ngrx/store'
import type {Order} from '@models/order/order'
import type {OrderProduct} from '@models/order/orderproduct'
import type {ActionResponse} from '@models/types/action-response.type'
import * as OrderActions from './orders.actions'

export type OrdersState = {
  orders: Order[]
  orderCart: {
    [id: string]: OrderProduct
  }
  response?: ActionResponse<{outletId: string; activityId: string; action: any; orderId: string}>
}

const initialState: OrdersState = {
  orders: [],
  orderCart: {},
  response: null,
}

const reducer = createReducer(
  initialState,
  on(OrderActions.getOrdersListResponse, (state, {orders}) => ({
    ...state,
    orders,
  })),
  on(OrderActions.resetOrders, state => ({...initialState})),
  on(OrderActions.resetOrderInProgress, state => ({...initialState, orders: state.orders})),
  on(OrderActions.resetCartProducts, state => ({...state, orderCart: {}})),
  on(OrderActions.saveOrderResponseResult, (state, response) => ({
    ...state,
    response,
  })),
  on(OrderActions.clearOrderResponseResult, state => ({
    ...state,
    response: null,
  }))
)

export const ordersReducer = (state: OrdersState | undefined, action: Action) => reducer(state, action)
